import { registerFeatureMessages, type SupportedLocale } from '@/shared/i18n'

export function registerGlobalSurfaceMessages(locale: SupportedLocale): Promise<void> {
  return registerFeatureMessages('globalSurface', locale)
}
